import { render, staticRenderFns } from "./QualityControlCard.vue?vue&type=template&id=bfbf033c"
import script from "./QualityControlCard.vue?vue&type=script&lang=js"
export * from "./QualityControlCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports